import { Component, input } from '@angular/core';

@Component({
  selector: 'app-offer-included-items-tab',
  imports: [],
  templateUrl: './offer-included-items-tab.html',
  styleUrl: './offer-included-items-tab.scss',
})
export class OfferIncludedItemsTab {
  offer = input.required<any>();
}
